// extracted by mini-css-extract-plugin
export var errorPage = "pages-__NotFound-module___errorPage";
export var errorTitle = "pages-__NotFound-module___errorTitle";